module.exports = __webpack_public_path__ + "static/media/ad.6a29be71.png";